import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import ProductsWithUnitsSoldSplineChart from 'src/components/BeaconV2Components/ExperimentalLayout/Sales/ProductsWithUnitsSoldSplineChart';
import UnitsSoldProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/UnitsSold/UnitsSoldProductGrid';
import { BeaconSplineChartWithPromotionsWrapper } from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Promotions/BeaconSplineChartWithPromotions';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const UnitsSoldPage = () => {
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_UNITS_SOLD.name}
          chartName={CHART_NAMES.BEACON_UNITS_SOLD_SPLINE}
        >
          <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="unitsSold" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_UNITS_SOLD_RETAIL_PRICE.name}
          chartName={CHART_NAMES.BEACON_UNITS_SOLD_RETAIL_PRICE_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="retailPrice" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_UNITS_SOLD_BY_ENTITY.name}
          chartName={CHART_NAMES.BEACON_UNITS_SOLD_BY_ENTITY_COLUMN}
        >
          <BeaconDropdownMetricColumnChart
            beaconChartWithLegendPropsBuilder={(props) => ({
              ...props,
              loadingComponent: <TopEntityChartV2Loading />
            })}
            indexName="sales"
            fieldName="unitsSold"
            dropdownOptions={[
              {
                id: 'subCategoryId',
                label: 'Subcategory'
              },
              {
                id: 'categoryId',
                label: 'Category'
              },
              {
                id: 'brandId',
                label: 'Brand'
              }
            ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
            titlePrefix="Units Sold by"
          />
        </ChartContextProvider>
        {entityType !== 'product' && (
          <ChartContextProvider
            group={CHART_CONTEXT_GROUPS.BEACON_PRODUCTS_WITH_UNITS_SOLD.name}
            chartName={CHART_NAMES.BEACON_PRODUCTS_WITH_UNITS_SOLD_SPLINE}
          >
            <ProductsWithUnitsSoldSplineChart />
          </ChartContextProvider>
        )}
        <UnitsSoldProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default UnitsSoldPage;
